// custom-product.js — product page supplement
// Activates UI elements added by the product revamp.
// Core gallery, variant, and recommendation logic lives in website-custom.js.

document.addEventListener('DOMContentLoaded', () => {
  initBundleNudge();
  initBundleOffer();
  initStickyBar();
  initMoreColourSection();
  initMoreColourFollowsSwatch();
  initColourSoftNav();
  initPersonalisation();
});

// Toggle the CTS (Complete the Set) panel via the bundle nudge bar.
function initBundleNudge() {
  const nudge   = document.getElementById('bundle-nudge');
  const ctsWrap = document.getElementById('cts-wrap');
  if (!nudge || !ctsWrap) return;

  nudge.addEventListener('click', () => {
    const open = ctsWrap.classList.toggle('open');
    nudge.classList.toggle('open', open);
  });
}

// Build-A-Bundle Offer callout (snippets/product-bundle-offer.liquid).
// Delegated: the markup lives inside the productVariantsVue root, which can
// re-render it, and Vue drops inline <script> there.
function initBundleOffer() {
  document.addEventListener('click', (e) => {
    const head = e.target.closest('[data-bab-toggle]');
    if (!head) return;
    const wrap = head.closest('[data-bab]');
    if (!wrap) return;
    const open = wrap.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

// Show mobile sticky ATC bar on scroll (delegates to website-custom.js if available).
function initStickyBar() {
  const bar = document.getElementById('sticky-bar');
  if (!bar) return;

  // Use the pre-built initSticky from website-custom.js if present.
  if (typeof initSticky === 'function') {
    initSticky();
    return;
  }

  // Fallback: simple IntersectionObserver on the product top section.
  const hero = document.getElementById('product-top');
  if (!hero) return;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (isMobile) {
    bar.classList.add('visible');
    return;
  }

  new IntersectionObserver(
    ([entry]) => bar.classList.toggle('visible', !entry.isIntersecting),
    { rootMargin: '-60px 0px 0px 0px', threshold: 0 }
  ).observe(hero);
}

// ── COLOUR MATCHING SECTION ───────────────────────────────────────────────────
// Fetches products from a Shopify collection via AJAX, then renders colour
// swatches and product cards automatically — no per-product or per-colour
// configuration needed in the theme editor.
// ATC uses the same $360.productEachAddToCart pattern as the YMAL section.

// Colour filters are driven by the "Color" metaobject, serialised into the section
// by product-details-section-cross-color.liquid — the same source the PDP swatches
// use, so the two can no longer drift apart.
//
// mcColours holds the subset actually offered: colours that exist in the fetched
// products, in metaobject order. `value` is the raw variant option value used for
// matching; name/hex/image are for display.
let mcColours = [];

function mcReadCatalogue() {
  const el = document.getElementById('mc-colour-catalogue');
  if (!el) return [];
  try {
    const list = JSON.parse(el.textContent);
    return Array.isArray(list) ? list.filter(c => c && c.name) : [];
  } catch (err) {
    console.warn('[colour matching] swatch catalogue is not valid JSON:', err);
    return [];
  }
}

function mcEscape(str) {
  return String(str).replace(/[&<>"']/g, ch => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
  ));
}

let mcActiveColour = 0;
let mcProducts     = [];

function mcReadProducts() {
  const el = document.getElementById('mc-products');
  if (!el) return [];
  try {
    const list = JSON.parse(el.textContent);
    return Array.isArray(list) ? list : [];
  } catch (err) {
    console.warn('[colour matching] product listing is not valid JSON:', err);
    return [];
  }
}

// The colours the section is allowed to offer, in the order the client listed them
// in the theme editor. Blank means "whatever the listing turns up".
function mcReadAllowed(sectionEl) {
  return (sectionEl.dataset.allowedColours || '')
    .split(',')
    .map(name => name.trim())
    .filter(Boolean);
}

// The colour(s) a product can be shown under. Split products carry one colour on
// the metaobject; un-split ones carry a colour per variant, so a single product
// can appear under several. Returns raw values, so a casing difference between the
// metaobject and the product data cannot silently empty the grid.
function mcProductColours(product) {
  if (product.colour) return [product.colour];
  if (!product.colourKey) return [];
  const seen = new Map();
  for (const v of product.variants) {
    const value = v[product.colourKey];
    if (value) seen.set(value.trim().toLowerCase(), value);
  }
  return Array.from(seen.values());
}

// Variants of `product` that belong to `colourValue`. A split product is entirely
// one colour, so all of its variants qualify.
function mcVariantsInColour(product, colourValue) {
  if (product.colour) {
    return product.colour.trim().toLowerCase() === colourValue.trim().toLowerCase()
      ? product.variants
      : [];
  }
  if (!product.colourKey) return [];
  return product.variants.filter(
    v => (v[product.colourKey] || '').trim().toLowerCase() === colourValue.trim().toLowerCase()
  );
}

function initMoreColourSection() {
  const sectionEl = document.querySelector('.product-details-section-cross-color');
  if (!sectionEl) return;

  const currentProductId = parseInt(sectionEl.dataset.productId, 10) || 0;

  // The colour this PDP is showing. Liquid resolves it from the variant option
  // (honouring ?variant=) or the custom.color metafield, and leaves it blank when
  // it knows neither — in which case we settle on the first colour with siblings.
  const defaultColour = sectionEl.dataset.defaultColour || '';

  // Reset to that colour before rendering. After a soft navigation the previous
  // colour's swatches and grid would otherwise sit under the new heading.
  const heading = document.getElementById('more-colour-label');
  if (heading && defaultColour) heading.textContent = defaultColour;
  const filters = document.getElementById('more-colour-filters');
  if (filters) filters.innerHTML = '';

  const grid = document.getElementById('more-grid');

  mcProducts = mcReadProducts()
    .filter(p => p.id !== currentProductId) // belt and braces; Liquid excludes it too
    .map(p => Object.assign({}, p, {
      featuredImage: p.image || null,
      variants: (p.variants || []).map(v => Object.assign({}, v, {
        // Liquid prices are cents; the rest of this section works in dollars.
        price: typeof v.price === 'number' ? v.price / 100 : NaN,
      })),
    }));

  // Offer only colours that actually exist in these products, ordered by the
  // metaobject.
  const present = new Map();
  mcProducts.forEach(p => mcProductColours(p).forEach(value => {
    present.set(value.trim().toLowerCase(), value);
  }));

  mcColours = mcReadCatalogue()
    .filter(c => present.has(c.name.trim().toLowerCase()))
    .map(c => Object.assign({}, c, { value: present.get(c.name.trim().toLowerCase()) }));

  const unlisted = Array.from(present.values()).filter(v => !mcColours.some(c => c.value === v));
  if (unlisted.length) {
    console.warn('[colour matching] no "Color" metaobject entry for:', unlisted.join(', '));
  }

  // Narrow to the offered colours, ordered as listed rather than by the
  // metaobject. Applied after the warning above so excluding a colour on purpose
  // is not reported as missing data.
  const allowed = mcReadAllowed(sectionEl);
  if (allowed.length) {
    const rank = new Map(allowed.map((name, i) => [name.toLowerCase(), i]));
    mcColours = mcColours
      .filter(c => rank.has(c.name.trim().toLowerCase()))
      .sort((a, b) => rank.get(a.name.trim().toLowerCase()) - rank.get(b.name.trim().toLowerCase()));

    const unknown = allowed.filter(name => !mcColours.some(
      c => c.name.trim().toLowerCase() === name.toLowerCase()
    ));
    if (unknown.length) {
      console.warn('[colour matching] offered colour not found in this listing:', unknown.join(', '));
    }
  }

  if (!mcColours.length) {
    if (grid) grid.innerHTML = '<p class="more-empty">No matching products available.</p>';
    return;
  }

  let idx = mcColours.findIndex(
    c => c.name.trim().toLowerCase() === defaultColour.trim().toLowerCase()
  );
  if (idx < 0) idx = 0; // this colour has no siblings here — fall back to the first

  mcRenderFilters();
  mcSetColour(idx); // sets the heading and renders the grid
}

// Un-split products switch colour in place via the PDP swatches, without a
// navigation, so the section has to follow that click itself. Split products
// navigate instead and are handled by the soft-nav hook further down.
function initMoreColourFollowsSwatch() {
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.color-swatch-wrapper .change-variant-trigger');
    if (!swatch) return;
    const value = swatch.dataset.variant;
    if (!value) return;
    const idx = mcColours.findIndex(
      c => c.name.trim().toLowerCase() === value.trim().toLowerCase()
    );
    if (idx >= 0) mcSetColour(idx);
  });
}

function mcRenderFilters() {
  const el = document.getElementById('more-colour-filters');
  if (!el) return;
  el.innerHTML = mcColours.map((c, i) => {
    // A few catalogue entries are patterns: an image instead of a flat hex.
    const bg = c.image
      ? `background-image:url(${c.image});background-size:cover;`
      : `background:${c.hex || '#e0e0e0'};`;
    return `
    <div class="more-filter-swatch ${i === mcActiveColour ? 'active' : ''}"
         style="${bg}"
         title="${mcEscape(c.name)}"
         onclick="mcSetColour(${i})"></div>`;
  }).join('');
}

function mcSetColour(idx) {
  if (!mcColours[idx]) return;
  mcActiveColour = idx;
  document.querySelectorAll('#more-colour-filters .more-filter-swatch')
    .forEach((el, i) => el.classList.toggle('active', i === idx));
  const label = document.getElementById('more-colour-label');
  if (label) label.textContent = mcColours[idx].name;
  mcRenderGrid();
}

function mcRenderGrid() {
  const el = document.getElementById('more-grid');
  if (!el) return;

  const colour = mcColours[mcActiveColour];
  if (!colour) { el.innerHTML = ''; return; }
  const cards = [];

  for (const product of mcProducts) {
    if (cards.length >= 4) break;

    // Variants that match the active colour
    const colourVariants = mcVariantsInColour(product, colour.value);
    if (!colourVariants.length) continue;

    // Colour-specific image: prefer first variant with a dedicated image
    const image = colourVariants.find(v => v.image)?.image || product.featuredImage;

    // Price the colour on screen, not the product: on an un-split product the
    // colours can sit at different price points, and the card only shows one.
    const prices = colourVariants.map(v => v.price).filter(v => Number.isFinite(v) && v > 0);
    const price  = prices.length ? { min: Math.min(...prices), max: Math.max(...prices) } : null;

    // Sizes available for this colour (OOS ones are disabled, not hidden).
    // Deduplicated by label: a product can carry a third option — the sleeping
    // bags are TOG x Size — which would otherwise repeat every size once per TOG.
    // An in-stock variant always wins the slot over a sold-out one.
    const bySize = new Map();
    for (const v of colourVariants) {
      const label = v[product.sizeKey] || 'One Size';
      const held  = bySize.get(label);
      if (!held || (!held.available && v.available)) {
        bySize.set(label, { id: v.id, label, available: v.available });
      }
    }
    const sizes = Array.from(bySize.values());

    // Resolved in the section: the card shows one badge, so shipping every
    // product's whole tag list to pick it was 50KB of the payload.
    cards.push(mcBuildCard(product, image, sizes, product.badge || null, price));
  }

  if (!cards.length) {
    el.innerHTML = '<p class="more-empty">No products available in this colour.</p>';
    return;
  }

  el.innerHTML = cards.join('');
}

// Prices here are dollars. The section prints the market's money format
// ("${{amount}} AUD" on /en-au), so the label follows the shopper's currency.
function mcFormatMoney(dollars) {
  const sectionEl = document.querySelector('.product-details-section-cross-color');
  const format = sectionEl ? sectionEl.dataset.moneyFormat : '';
  const cents = Math.round(dollars * 100);
  if (format && window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format).replace(' MYR', '');
  }
  return `$${(cents / 100).toFixed(2)}`;
}

function mcBuildCard(product, image, sizes, badge, price) {
  // Already sized by image_url in the section.
  const imgSrc = image || '';

  // Name the garment, not the colour: the grid already sits under a colour
  // heading. Un-split products have no group and no colour suffix either, so
  // their own title is already the right label.
  const name = product.group || product.title;

  const priceLabel = price
    ? `${price.max > price.min ? 'From ' : ''}${mcFormatMoney(price.min)}`
    : '';

  const sizeOpts = sizes.map(s =>
    `<option value="${s.id}" ${s.available ? '' : 'disabled'}>${s.label}${s.available ? '' : ' – Sold Out'}</option>`
  ).join('');

  return `
    <div class="more-card">
      <a href="${product.url}" class="more-card-img-link">
        <div class="more-card-img" style="overflow:hidden;">
          ${imgSrc ? `<img src="${imgSrc}" alt="${mcEscape(name)}" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy">` : ''}
          ${badge ? `<span class="more-card-badge${badge.toLowerCase().startsWith('new') ? ' new' : ''}">${badge}</span>` : ''}
        </div>
      </a>
      <div class="more-card-body">
        <a href="${product.url}" class="more-card-name">${mcEscape(name)}</a>
        ${priceLabel ? `<div class="more-card-price">${priceLabel}</div>` : ''}
      </div>
      <select
        class="more-size-select"
        onclick="event.stopPropagation()"
        onchange="mcSizeChange(${product.id}, this)">
        <option value="" disabled selected>Select a size</option>
        ${sizeOpts}
      </select>
      <form method="post" action="${window.Shopify.routes.root}cart/add" class="product-form">
        <input type="hidden" name="id" id="mc-variant-${product.id}" value="">
        <button
          class="more-add-btn add-to-cart"
          id="mc-atc-${product.id}"
          disabled
          onclick="$360.productEachAddToCart(event)"
          data-tag="colour-matching">
          Add to Cart
        </button>
      </form>
    </div>
  `;
}

function mcSizeChange(productId, selectEl) {
  const variantId   = selectEl.value;
  const hiddenInput = document.getElementById(`mc-variant-${productId}`);
  const btn         = document.getElementById(`mc-atc-${productId}`);
  if (!hiddenInput || !btn) return;
  hiddenInput.value = variantId;
  btn.disabled = !variantId;
  btn.classList.toggle('ready', !!variantId);
}

// ── COLOUR SOFT NAVIGATION ────────────────────────────────────────────────────
// Colour swatches point at sibling products, so switching colour is a real
// navigation. This upgrades it to an in-place swap: fetch the target page, swap
// the contents of the product-top section, and pushState — no reload, no scroll
// jump. Anything unexpected falls back to a normal navigation.
//
// The section ELEMENT is kept and only its innerHTML is replaced. That matters:
// the sticky-button scroll listener and scrollToProductTop() from product-top
// .liquid are keyed to "#shopify-section-<id>", so preserving the element keeps
// both alive and lets us skip re-running that script.

const CSN_SECTION = '[id^="shopify-section"][id$="__product-top"], #shopify-section-product-top';

const csnCache = new Map();
let csnToken = 0;

function initColourSoftNav() {
  if (!window.history || !window.history.pushState) return;
  if (!document.querySelector(CSN_SECTION)) return;
  if (!document.querySelector('.color-group-swatch')) return;

  document.addEventListener('click', csnOnClick);
  document.addEventListener('mouseover', csnOnHover, { passive: true });
  window.addEventListener('popstate', () => csnSwap(window.location.href, false));
}

function csnOnClick(e) {
  if (e.defaultPrevented || e.button !== 0) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  const link = e.target.closest && e.target.closest('.color-group-swatch');
  if (!link || !link.href) return;

  // Already on this colour — swallow the click rather than reloading.
  if (link.classList.contains('active')) { e.preventDefault(); return; }

  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin) return;

  e.preventDefault();
  csnSwap(url.href, true);
}

// Warm the cache while the cursor is still travelling to the swatch.
function csnOnHover(e) {
  const link = e.target.closest && e.target.closest('.color-group-swatch');
  if (!link || !link.href || link.classList.contains('active')) return;
  csnFetch(new URL(link.href, window.location.href).href).catch(() => {});
}

function csnFetch(url) {
  if (csnCache.has(url)) return csnCache.get(url);
  const req = fetch(url, { credentials: 'same-origin' }).then(res => {
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.text();
  });
  csnCache.set(url, req);
  req.catch(() => csnCache.delete(url));
  return req;
}

async function csnSwap(url, push) {
  const section = document.querySelector(CSN_SECTION);
  if (!section) { window.location.href = url; return; }

  const token = ++csnToken;
  const hadFocus = document.activeElement &&
                   document.activeElement.classList &&
                   document.activeElement.classList.contains('color-group-swatch');
  section.classList.add('csn-loading');

  try {
    const html = await csnFetch(url);
    if (token !== csnToken) return; // a later click already took over

    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector(CSN_SECTION);
    if (!next) throw new Error('product-top section missing in response');

    // Klaviyo's back-in-stock widget reads the product once, from the URL at page
    // load, and keeps it in a closure we cannot reach or re-run. After a swap it
    // still holds the colour we came from, so the waitlist never shows (and would
    // subscribe to the wrong product). Any colour with a sold-out variant needs
    // the waitlist, so it gets a real page load.
    if (csnNeedsWaitlist(next)) {
      window.location.href = url;
      return;
    }

    // Tear the old Vue app down before its DOM disappears.
    const form = section.querySelector('#product-form');
    if (form && form.__vue_app__) {
      try { form.__vue_app__.unmount(); } catch (err) { /* non-fatal */ }
    }

    section.innerHTML = next.innerHTML;
    csnRunScripts(section);

    // If the variant app did not come back up, ATC would be dead — bail out to a
    // real navigation instead of leaving a broken page on screen.
    const newForm = section.querySelector('#product-form');
    if (!newForm || !newForm.__vue_app__) throw new Error('variant app did not mount');

    if (push) window.history.pushState({ colourSoftNav: true }, '', url);
    csnUpdateHead(doc, url);
    csnReinit(doc);

    if (hadFocus) {
      const active = section.querySelector('.color-group-swatch.active');
      if (active) active.focus();
    }
  } catch (err) {
    if (token !== csnToken) return;
    console.warn('[colour soft nav] falling back to a full page load:', err);
    window.location.href = url;
  } finally {
    section.classList.remove('csn-loading');
  }
}

// Same test Klaviyo makes: the product has at least one unavailable variant.
// .variant-data-each is rendered per variant by product-variants.liquid.
function csnNeedsWaitlist(section) {
  if (!section.querySelector('.klaviyo-bis-trigger')) return false;
  return !!section.querySelector('.variant-data-each:not(.available)');
}

// Scripts injected via innerHTML never execute — re-run the ones that carry
// per-product state, and only those.
function csnRunScripts(root) {
  const scripts = Array.from(root.querySelectorAll('script:not([src])')).filter(s => {
    const type = (s.type || '').toLowerCase();
    if (type && type !== 'text/javascript' && type !== 'application/javascript') return false;
    // Skip the sticky-button block: its listener from the first load still points
    // at this same section element, and re-running it stacks duplicate handlers.
    return !/end_section_pos/.test(s.textContent);
  });

  // The page fired DOMContentLoaded long ago, so callbacks registered now would
  // never run. Invoke them immediately for the duration of this swap.
  const origAdd = document.addEventListener;
  document.addEventListener = function (type, fn, opts) {
    if (type === 'DOMContentLoaded') {
      try { fn(); } catch (err) { console.warn('[colour soft nav] ready handler failed:', err); }
      return;
    }
    return origAdd.call(document, type, fn, opts);
  };

  try {
    scripts.forEach(s => {
      try {
        // Function scope, not global: the section declares `const product` and
        // `const productVariantsVue` at top level, which would throw a
        // redeclaration error on a second evaluation in the global scope.
        new Function(s.textContent)();
      } catch (err) {
        console.warn('[colour soft nav] section script failed:', err);
      }
    });
  } finally {
    document.addEventListener = origAdd;
  }
}

function csnUpdateHead(doc, url) {
  if (doc.title) document.title = doc.title;

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute('href', url);

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) ogUrl.setAttribute('content', url);

  const nextDesc = doc.querySelector('meta[name="description"]');
  const desc     = document.querySelector('meta[name="description"]');
  if (desc && nextDesc) desc.setAttribute('content', nextDesc.getAttribute('content'));
}

function csnReinit(doc) {
  // Images in the swapped markup are lazy (data-src, class="lazy"). The theme's
  // vanilla-lazyload instance only knows about nodes it has already scanned, so it
  // has to be updated — the same call the theme's own AJAX paths make after
  // injecting HTML. Without this the USP icons never load.
  // $360 is a top-level `const` in vendor.js, so it lives in the global lexical
  // scope and is NOT reachable as window.$360 — check the bare identifier.
  if (typeof $360 !== 'undefined' && $360.lazyLoadInstance) $360.lazyLoadInstance.update();

  // Gallery, rewards and personalisation CTA all read the markup we just swapped.
  if (typeof buildThumbs === 'function') buildThumbs();
  if (typeof initGalleryArrows === 'function') initGalleryArrows();
  if (typeof updateRewardsPoints === 'function') updateRewardsPoints();
  if (typeof setPersonaliseCTALink === 'function') setPersonaliseCTALink();

  initBundleNudge();
  initPersonalisation();
  if (document.getElementById('product-top')) initStickyBar();

  // Colour Matching sits outside product-top, so point it at the new colour.
  const mc   = document.querySelector('.product-details-section-cross-color');
  const next = doc.querySelector('.product-details-section-cross-color');
  if (mc && next) {
    if (next.dataset.defaultColour) mc.dataset.defaultColour = next.dataset.defaultColour;
    if (next.dataset.productId)     mc.dataset.productId     = next.dataset.productId;

    // Take the incoming listing too. It is the same collection, but each page
    // renders it with the product being viewed removed — keeping the old one
    // would hide the product just navigated away from.
    const mcData   = mc.querySelector('#mc-products');
    const nextData = next.querySelector('#mc-products');
    if (mcData && nextData) mcData.textContent = nextData.textContent;

    // initMoreColourSection() reads data-default-colour and resets the heading,
    // the swatches and the grid from it.
    initMoreColourSection();
  }
}

// ── ON-PAGE PERSONALISATION ───────────────────────────────────────────────────
// Drives the inline personalisation block rendered by
// snippets/product-personalisation-inline.liquid, which replaced the slide-in
// panel on the PDP.
//
// State lives in the DOM, not in a variable: whether the option is on is read
// off #pers-cb, the selected thread off .thread-sw.active. That keeps this
// module correct after the colour soft nav swaps the whole product-top section,
// and lets the Vue addToCart() in product-variants.liquid ask for the current
// values at the moment of the cart call.
//
// Listeners are delegated from document for the same reason — nothing to rebind
// when the markup is replaced.
//
// Latin and Chinese are two separate inputs, not one input in two modes, and a
// toggle says which pair is live. inputs() resolves to the live pair and every
// other method reads through it, so the cart, validation and the ATC total all
// follow the toggle without knowing it exists. Latin is what loads, which is
// why .pers-input and formatInput() below are untouched by any of this.

const pdpPers = {
  block() {
    return document.getElementById('pers-block');
  },

  isRequired() {
    const el = this.block();
    return !!el && el.dataset.required === 'true';
  },

  // Is personalisation being bought with this product?
  isEnabled() {
    const el = this.block();
    if (!el) return false;
    if (this.isRequired()) return true;
    const cb = el.querySelector('#pers-cb');
    return !!cb && cb.classList.contains('checked');
  },

  // 'latin' or 'cjk'. Read off the DOM like everything else here, so it stays
  // right after the colour soft nav replaces the section.
  script() {
    const el = this.block();
    if (!el) return 'latin';
    const active = el.querySelector('.pers-script.active');
    return active && active.dataset.script === 'cjk' ? 'cjk' : 'latin';
  },

  // The live fields. Only these are read into the cart and only these are
  // validated — the hidden side is emptied on switch and never consulted.
  inputs() {
    const el = this.block();
    if (!el) return [];
    const selector = this.script() === 'cjk' ? '.pers-input-cjk' : '.pers-input';
    return Array.from(el.querySelectorAll(selector));
  },

  feeVariantId() {
    const el = this.block();
    return el ? parseInt(el.dataset.feeVariant, 10) : null;
  },

  // The fee product's own price — what the cart is told the fee is. Whether
  // this one goes in as the $0 twin is decided at the cart call by
  // assets/personalisation-quota.js, which rewrites the properties to match.
  paidFeeCents() {
    const el = this.block();
    return el ? parseInt(el.dataset.feeCents, 10) || 0 : 0;
  },

  // What the shopper will be charged for it: $0 while the order still has
  // complimentary personalisations left (and this fee has a $0 twin).
  feeCents() {
    const el = this.block();
    if (!el) return 0;
    const quota = window.persQuota;
    const remaining = quota ? quota.remaining() : null;
    if (el.dataset.feeComp === 'true' && remaining !== null && remaining > 0) return 0;
    return this.paidFeeCents();
  },

  feeFormatted() {
    const el = this.block();
    return el ? el.dataset.feeFormatted || '' : '';
  },

  forTitle() {
    const el = this.block();
    return el ? el.dataset.for || '' : '';
  },

  threadName() {
    const el = this.block();
    if (!el) return '';
    const active = el.querySelector('.thread-sw.active');
    return active ? active.dataset.name : '';
  },

  money(cents) {
    const el = this.block();
    const format = el ? el.dataset.moneyFormat : '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || undefined).replace(' MYR', '');
    }
    return (cents / 100).toFixed(2);
  },

  // The price the shopper is actually on. Liquid seeds it; the variant handler
  // in product-variants.liquid pushes every change through setBaseCents(). The
  // Vue app is deliberately not read here — after a colour soft nav its section
  // script is re-run inside a function scope, so the global binding is stale.
  baseCents() {
    const el = this.block();
    return el ? parseInt(el.dataset.baseCents, 10) || 0 : 0;
  },

  // Called on every variant change, so the total on the button stays honest.
  setBaseCents(cents) {
    const el = this.block();
    if (!el) return;
    const value = parseInt(cents, 10);
    if (!isNaN(value)) el.dataset.baseCents = value;
    this.refreshAtcLabel();
  },

  // ── Cart ──
  // Line-item properties for the main product. Property names are resolved in
  // Liquid and carried on each control, so the naming stays in one place.
  getProperties() {
    const el = this.block();
    if (!el || !this.isEnabled()) return {};

    const properties = {
      _group_parent: 'true',
      _pers_fee_num: String(this.paidFeeCents()),
    };

    this.inputs().forEach((input) => {
      const name = input.dataset.propName;
      if (!name) return;
      const value = input.value.trim();
      properties[name] = input.classList.contains('uppercase') ? value.toUpperCase() : value;
    });

    properties[el.dataset.threadProp || 'Thread Colour'] = this.threadName();

    // The text itself goes out under the same property name either way, so
    // nothing downstream has to change to keep reading it. This is the only
    // thing that says which face to stitch it in.
    const scriptProp = el.dataset.scriptProp;
    if (scriptProp) {
      properties[scriptProp] = this.script() === 'cjk' ? 'Chinese' : 'Latin';
    }

    properties['Personalisation Fee'] = this.feeFormatted();

    return properties;
  },

  // What the WenKai subset can draw is BMP only. Anything astral is a surrogate
  // pair here — emoji above all — and would go to production as something that
  // cannot be stitched, so it is refused along with a field holding no Chinese
  // at all (usually a shopper who typed a Latin name under the 中文 tab).
  cjkFieldInvalid(value) {
    if (/[\uD800-\uDFFF]/.test(value)) return true;
    return !/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(value);
  },

  // Every live field has to be filled before the cart call goes out.
  validate() {
    const el = this.block();
    if (!el || !this.isEnabled()) return true;

    const inputs = this.inputs();

    const empty = inputs.find((input) => input.value.trim() === '');
    if (empty) return this.showError(empty, '#pers-error');

    if (this.script() === 'cjk') {
      const bad = inputs.find((input) => this.cjkFieldInvalid(input.value.trim()));
      if (bad) return this.showError(bad, '#pers-error-cjk');
    }

    this.clearError();
    return true;
  },

  showError(input, selector) {
    const el = this.block();
    if (!el) return false;
    this.clearError();
    const error = el.querySelector(selector);
    if (error) error.classList.add('show');
    input.classList.add('is-error');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus();
    return false;
  },

  clearError() {
    const el = this.block();
    if (!el) return;
    el.querySelectorAll('.pers-error').forEach((e) => e.classList.remove('show'));
    el
      .querySelectorAll('.pers-input.is-error, .pers-input-cjk.is-error')
      .forEach((i) => i.classList.remove('is-error'));
  },

  // ── UI ──
  toggle() {
    const el = this.block();
    if (!el || this.isRequired()) return;

    const cb   = el.querySelector('#pers-cb');
    const row  = el.querySelector('.pers-toggle-row');
    const body = el.querySelector('#pers-fields');
    if (!cb || !body) return;

    const on = !cb.classList.contains('checked');
    cb.classList.toggle('checked', on);
    body.classList.toggle('show', on);
    if (row) row.setAttribute('aria-checked', on ? 'true' : 'false');

    if (!on) this.clearError();
    this.refreshAtcLabel();

    if (on) {
      const first = this.inputs()[0];
      if (first) first.focus();
    }
  },

  // Switching only hides the other side, it does not empty it — a shopper who
  // looks at the Chinese tab and comes back still has the name they typed.
  // Nothing leaks, because the cart and validation both go through inputs(),
  // which only ever returns the live pair. Nothing here runs unless the toggle
  // is clicked, so the Latin default path never passes through it.
  setScript(button) {
    const el = this.block();
    if (!el || !button) return;

    const target = button.dataset.script === 'cjk' ? 'cjk' : 'latin';
    if (target === this.script()) return;

    el.querySelectorAll('.pers-script').forEach((b) => {
      const on = b === button;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    el.querySelectorAll('.pers-input, .pers-input-cjk').forEach((input) => {
      const live = input.classList.contains('pers-input-cjk') === (target === 'cjk');
      input.hidden = !live;
    });

    this.clearError();
    const first = this.inputs()[0];
    if (first) first.focus();
  },

  setThread(swatch) {
    const el = this.block();
    if (!el || !swatch) return;
    el.querySelectorAll('.thread-sw').forEach((s) => s.classList.remove('active'));
    swatch.classList.add('active');
    const label = el.querySelector('#pers-thread-name');
    if (label) label.textContent = swatch.dataset.name || '';
  },

  // Lifts the first character the way the panel did, but restores the caret so
  // editing mid-word no longer throws the cursor to the end.
  formatInput(input) {
    let value = input.value.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
    if (value) value = value.charAt(0).toUpperCase() + value.slice(1);
    if (value !== input.value) {
      const at = input.selectionStart;
      input.value = value;
      try { input.setSelectionRange(at, at); } catch (err) { /* unsupported */ }
    }
    if (value.trim() !== '') this.clearError();
  },

  // The button carries the fee, so the shopper sees the real total before
  // committing. Availability wins: an Unavailable / disabled button is left be.
  //
  // The wording is never hardcoded — the label Liquid rendered is remembered on
  // first pass and the total appended to it, so the button stays translated and
  // the variant handler's own "Add to Cart" cannot leave the two out of step.
  // "+ SGD $15.00" until the cart is read, then "+ SGD $0.00" if this one
  // would be complimentary. Same wording either way, only the amount moves.
  refreshFee() {
    const el = this.block();
    if (!el) return;
    const label = el.querySelector('.pers-price');
    if (label) label.textContent = `+ ${this.money(this.feeCents())}`;
    this.refreshAtcLabel();
  },

  refreshAtcLabel() {
    if (!this.block()) return;
    const total = this.money(this.baseCents() + this.feeCents());

    ['#atc-button', '#sticky-atc-btn'].forEach((selector) => {
      const btn = document.querySelector(selector);
      if (!btn) return;
      if (btn.getAttribute('data-available') === 'false' || btn.hasAttribute('disabled')) return;

      if (!btn.dataset.persBaseLabel) btn.dataset.persBaseLabel = btn.textContent.trim();
      const base = btn.dataset.persBaseLabel;

      btn.innerHTML = this.isEnabled() ? `${base} — ${total}` : base;
    });
  },
};

window.pdpPers = pdpPers;

function initPersonalisation() {
  if (!pdpPers.block()) return;
  pdpPers.refreshFee();
}

// The cart was read or changed: the fee may have moved between $0 and full
document.addEventListener('pers-quota:change', () => pdpPers.refreshFee());

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('#pers-block .thread-sw');
  if (swatch) {
    e.preventDefault();
    pdpPers.setThread(swatch);
    return;
  }

  const script = e.target.closest('#pers-block .pers-script');
  if (script) {
    e.preventDefault();
    pdpPers.setScript(script);
    return;
  }

  // Ignore clicks that land on a field — only the header row toggles.
  const row = e.target.closest('#pers-block .pers-toggle-row');
  if (row) pdpPers.toggle();
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const row = e.target.closest('#pers-block .pers-toggle-row');
  if (!row) return;
  e.preventDefault();
  pdpPers.toggle();
});

document.addEventListener('input', (e) => {
  const input = e.target.closest('#pers-block .pers-input');
  if (input) pdpPers.formatInput(input);
});

// The Chinese field gets its own handler, and the first thing it does is stand
// aside for the IME. Typing pinyin fires an input event per keystroke while the
// composition is still open, and writing back to .value during one tears the
// composition apart — which is why formatInput() above must never see this
// field. There is nothing to reformat here either: Chinese has no casing, and
// the value is trimmed on the way to the cart.
document.addEventListener('input', (e) => {
  const input = e.target.closest('#pers-block .pers-input-cjk');
  if (!input || e.isComposing) return;
  if (input.value.trim() !== '') pdpPers.clearError();
});

/* ── GALLERY VIDEO ────────────────────────────────────────────────────────────
   The gallery itself (thumbs, arrows, swipe) lives in website-custom.js and only
   ever swaps one <img>. A video thumb carries its preview image there like any
   other, and selThumb() calls this to lay the playable markup over it.

   The markup is cloned fresh from its <template> each time and thrown away on
   the way out, which is the whole pause story: a removed <video> stops loading
   and a removed YouTube/Vimeo iframe stops playing, with no player API needed.
   Autoplay is muted, looped and controls-free, so mobile browsers allow it and
   nothing inside the frame competes with the gallery's own swipe. */
function gallerySyncVideo(thumb) {
  const holder = document.getElementById('gallery-main-video');
  if (!holder) return;

  const type = thumb?.dataset.type;
  const tpl  = (type === 'video' || type === 'external_video')
    && document.getElementById('gallery-video-' + thumb.dataset.mediaId);

  if (!tpl) {
    galleryHideVideo();
    return;
  }
  // Already showing this one — don't restart it on a repeat click.
  if (holder.dataset.mediaId === thumb.dataset.mediaId && !holder.hidden) return;

  holder.replaceChildren(tpl.content.cloneNode(true));
  holder.dataset.mediaId = thumb.dataset.mediaId;
  holder.hidden = false;

  // Some browsers ignore the autoplay attribute on a node inserted after load.
  const video = holder.querySelector('video');
  if (video) {
    video.muted = true;
    video.play?.().catch(() => {});
  }
}

function galleryHideVideo() {
  const holder = document.getElementById('gallery-main-video');
  if (!holder || holder.hidden) return;
  holder.hidden = true;
  holder.replaceChildren();
  delete holder.dataset.mediaId;
}
